import { ReactComponent as FeatherIcone } from 'core/assets/images/icones/featherIcone.svg'
import Loader from 'core/components/common/Loader'
import { ModalBody } from 'core/components/common/ModalBody'
import { ModalHeader } from 'core/components/common/ModalHeader'
import ModalWrapper from 'core/components/common/ModalWrapper'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import { t } from 'i18next'
import { PromptHistoryCard } from 'lauria/components/prompts/PromptHistoryCard'

export const PromptHistoriesModal = ({
  open,
  setOpen,
  promptHistorises,
  isLoading,
  handleRetrieveHistory,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  promptHistorises?: IPromptHistory[]
  isLoading: boolean
  handleRetrieveHistory: (promptHistory: IPromptHistory) => void
}) => {
  const hide = () => {
    setOpen(false)
  }
  return (
    <ModalWrapper
      center={false}
      classNames={{
        modal: 'modal modal-histories-prompt modal-histories-prompt-drawer',
        overlay: 'modal-histories-prompt-overlay',
      }}
      onClose={hide}
      open={open}
      showCloseIcon
      styles={{ overlay: { backgroundColor: 'transparent' } }}
    >
      <ModalHeader>
        <div className="flex items-center gap-x-[10px] dark:text-gray-1325">
          <FeatherIcone />
          {t('prompts.historise.title')}
        </div>
      </ModalHeader>
      <ModalBody className="py-[10px] px-[30px]">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Loader pageCenter />
          </div>
        ) : (
          <div className="flex flex-col gap-y-[30px]">
            {promptHistorises && promptHistorises.length > 0 ? (
              promptHistorises.map((promptHistory) => (
                <div
                  key={promptHistory.id}
                  className="flex flex-col gap-y-[10px]"
                >
                  <PromptHistoryCard
                    key={promptHistory.id}
                    promptHistory={promptHistory}
                  />
                  <div className="ml-[30px] flex flex-row items-center justify-between">
                    <div>
                      {t('prompts.historise.updated', {
                        date: new Date(
                          promptHistory.dateHistorisation
                        ).toLocaleDateString('fr-FR'),
                        time: new Date(
                          promptHistory.dateHistorisation
                        ).toLocaleTimeString('fr-FR', {
                          hour: '2-digit',
                          minute: '2-digit',
                        }),
                      })}
                    </div>
                    <button
                      className="small-btn default"
                      onClick={() => handleRetrieveHistory(promptHistory)}
                    >
                      {t('prompts.historise.retrieve')}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="mt-[10px]">
                {t('prompts.historise.noHistories')}
              </div>
            )}
          </div>
        )}
      </ModalBody>
    </ModalWrapper>
  )
}
